import { render, staticRenderFns } from "./Mention.vue?vue&type=template&id=0dab4364&"
import script from "./Mention.vue?vue&type=script&lang=ts&"
export * from "./Mention.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports